import React from 'react';
import {
  withRouter,
} from 'react-router';

import {
  urls,
} from 'web-urls';

import {
  Tooltip,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import SidebarItem from './SidebarItem';

import * as S from './styled';

type SidebarItemType = {
  name: string;
  link: string;
  icon: string;
};

type Props = {
  items: SidebarItemType[];
  location: any;
  openedTooltips: string[];
  onClickItem: { (item: SidebarItemType): void };
  namespace: any;
};

const Sidebar = ({
  items,
  location,
  namespace,
  openedTooltips,
  onClickItem,
}: Props) => (
  <S.Sidebar>
    <S.Logo
      to={urls.dashboardPage}
      logo={namespace.logo?.url}
    />
    <Flex
      column
      scrollY
      width="100%"
      padding="0 0 20px 0"
      data-tour="tour__nav"
    >
      {items.map(item => (openedTooltips.includes(item.name) ? (
        <Tooltip
          key={item.link}
          theme="light"
          body={`Click ${item.name}.`}
          toggleMode
          initialState
        >
          <SidebarItem
            {...item}
            currentPath={location.pathname || ''}
            onClick={() => onClickItem(item)}
          />
        </Tooltip>
      ) : (
        <SidebarItem
          key={item.link}
          currentPath={location.pathname || ''}
          {...item}
        />
      )))}
    </Flex>
  </S.Sidebar>
);

export default withRouter(Sidebar);
